export default {
  setErrorCode(state, errorCode) {
    state.errorCode = errorCode;
  },
  setRedirect(state, redirect) {
    state.redirect = redirect;
  },
  setErrorType(state, errorType){
    state.errorType = errorType;
  }
};
